<script lang="ts">
  export let fill = '#112334';
</script>

<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 6.69531L0 0.695312H12L6 6.69531Z" {fill} />
</svg>
